module.exports = __webpack_public_path__ + "4da27499a887165c042e852813e229a2.png";